import React from 'react';
import { Channel, DateSeparator } from 'stream-chat-react';
import Moment from 'moment-timezone';
import { ChannelInner } from './ChannelInner';
import { ChannelEmptyState } from '../ChannelEmptyState';
import { Message } from '../Message';
import { MessageInput } from '../MessageInput';
import { CustomTriggerProvider } from './CustomTriggerProvider';
import './ChannelContainer.css';

const formatDateSeparator = (date) => Moment(date).tz("America/Los_Angeles").format("MMMM, DD YYYY");

export const ChannelContainer = () => {
  return (
    <div className='channel__container'>
      <Channel
        EmptyStateIndicator={ChannelEmptyState}
        DateSeparator={(messageProps)=> <DateSeparator {...messageProps} formatDate={formatDateSeparator} />}
        Input={MessageInput}
        Message={(messageProps, i) => <Message key={i} {...messageProps} />}
        TypingIndicator={() => null}
        TriggerProvider={CustomTriggerProvider}
      >
        <ChannelInner />
      </Channel>
    </div>
  );
};
